var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "divBox" },
    [
      _c(
        "el-card",
        { staticClass: "box-card" },
        [
          _c("div", { staticClass: "flex justify-between mb46" }, [
            _c("div", { staticClass: "header_title" }, [_vm._v("商品概况")]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "acea-row" },
              [
                _c(
                  "div",
                  { staticClass: "mr-20" },
                  [
                    _c(
                      "el-radio-group",
                      {
                        staticClass: "mr20",
                        attrs: { type: "button", size: "small" },
                        on: {
                          change: function ($event) {
                            return _vm.selectChange(_vm.dateLimit)
                          },
                        },
                        model: {
                          value: _vm.dateLimit,
                          callback: function ($$v) {
                            _vm.dateLimit = $$v
                          },
                          expression: "dateLimit",
                        },
                      },
                      _vm._l(_vm.fromList.fromTxt, function (item, i) {
                        return _c(
                          "el-radio-button",
                          { key: i, attrs: { label: item.val } },
                          [_vm._v(_vm._s(item.text))]
                        )
                      }),
                      1
                    ),
                    _vm._v(" "),
                    _c("el-date-picker", {
                      staticStyle: { width: "220px", height: "34px" },
                      attrs: {
                        size: "small",
                        type: "daterange",
                        placement: "bottom-end",
                        "picker-options": _vm.pickerOptions,
                        "value-format": "yyyy-MM-dd",
                        format: "yyyy-MM-dd",
                        "range-separator": "至",
                        "start-placeholder": "开始日期",
                        "end-placeholder": "结束日期",
                        align: "right",
                      },
                      on: { change: _vm.onchangeTime },
                      model: {
                        value: _vm.timeVal,
                        callback: function ($$v) {
                          _vm.timeVal = $$v
                        },
                        expression: "timeVal",
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-button",
                  {
                    staticClass: "mr10",
                    attrs: { type: "primary", size: "small" },
                    on: { click: _vm.onSeach },
                  },
                  [_vm._v("查询")]
                ),
                _vm._v(" "),
                _c(
                  "el-button",
                  {
                    attrs: {
                      type: "default",
                      size: "small",
                      icon: "el-icon-upload2",
                    },
                    on: { click: _vm.exports },
                  },
                  [_vm._v(" 导出")]
                ),
              ],
              1
            ),
          ]),
          _vm._v(" "),
          _vm.checkPermi(["admin:statistics:product:data"])
            ? _c(
                "div",
                { staticClass: "flex flex-wrap mb20" },
                _vm._l(_vm.list, function (item, index) {
                  return _c(
                    "div",
                    { key: index, staticClass: "infoBox acea-row mb30" },
                    [
                      _c(
                        "div",
                        { staticClass: "iconCrl mr15", class: item.class },
                        [
                          _c("i", {
                            staticClass: "iconfont",
                            class: item.icon,
                            style: { color: item.color },
                          }),
                        ]
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "info" }, [
                        _c(
                          "div",
                          { staticClass: "flex align-center" },
                          [
                            _c("span", {
                              staticClass: "sp1",
                              domProps: { textContent: _vm._s(item.name) },
                            }),
                            _vm._v(" "),
                            _c(
                              "el-tooltip",
                              {
                                staticClass: "pl10",
                                attrs: {
                                  effect: "dark",
                                  placement: "top-start",
                                },
                              },
                              [
                                _c("i", {
                                  staticClass: "el-icon-warning-outline",
                                }),
                                _vm._v(" "),
                                _c("div", {
                                  staticStyle: { "max-width": "400px" },
                                  attrs: { slot: "content" },
                                  domProps: { textContent: _vm._s(item.info) },
                                  slot: "content",
                                }),
                              ]
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        index === _vm.list.length - 1
                          ? _c("span", {
                              staticClass: "sp2",
                              domProps: { textContent: _vm._s(item.list.num) },
                            })
                          : _c("span", {
                              staticClass: "sp2",
                              domProps: { textContent: _vm._s(item.list.num) },
                            }),
                        _vm._v(" "),
                        _c("span", { staticClass: "content-time" }, [
                          _c("i", { class: item.ratio >= 0 ? "up" : "down" }, [
                            _vm._v(_vm._s(item.list.percent)),
                          ]),
                          _vm._v(" "),
                          _c("i", {
                            class:
                              item.ratio >= 0
                                ? "el-icon-caret-top"
                                : "el-icon-caret-bottom",
                            attrs: {
                              color: item.ratio >= 0 ? "#F5222D" : "#39C15B",
                            },
                          }),
                        ]),
                      ]),
                    ]
                  )
                }),
                0
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.optionData && _vm.checkPermi(["admin:statistics:product:trend"])
            ? _c("echarts-new", {
                attrs: {
                  "option-data": _vm.optionData,
                  styles: _vm.style,
                  height: "100%",
                  width: "100%",
                },
              })
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }